import React from 'react'
import styled from 'styled-components'
import { ExternalLink } from '../../../theme'


const BtnBox = styled.div`
  background: #EBA900;
  width: 210px;
  height: 40px;
  line-height: 40px;
  border-radius: 10px;
`
const AboutLink = styled(ExternalLink)`
  color: ${({ theme }) => theme.bsBg18};
  text-align: center;
  justify-content: center;
  display: flex;
  align-items: center;
  font-family: Baloo Da;
  text-decoration: none;

  &:hover{
    text-decoration: none;
  }
  ${({ theme }) => theme.mediaWidth.upToSmall`
    margin-left: 0;
    margin-right: 8px;
  `};
  & > img{
    margin-left: 10px;
  }
`

export default function WebsiteBtn({width, link}: {width?: string, link: string}) {
  return (
    <BtnBox style={{width: width + 'px'}}>
      <AboutLink href={link} target='_blank'>
        Battle Pets Website
        <img src="/images/bakery/icon_open_link.svg" alt=""/>
      </AboutLink>
    </BtnBox>
  )
}